/**
 * The canonical host for absolute URLs emitted in page metadata.
 *
 * Matches `siteMetadata.siteUrl` in `gatsby-config.js` and the production
 * deploy target. `gatsby-plugin-canonical-urls` and `gatsby-plugin-sitemap`
 * still emit the apex host instead; reconciling those two is a separate
 * decision, since it moves whatever is currently indexed.
 */
export const SITE_URL = 'https://www.kumargallery.com';

/**
 * The one part of Gatsby's page `location` prop needed to address the page.
 *
 * Note that it has to be `location`, not the sibling `path` prop: `path` is the
 * Reach Router *route pattern* Gatsby registers its pages under, which is the
 * catch-all `/*` on every page. `uri` is no better — it reports `/`, the part
 * of the URL that matched that pattern. `location.pathname` is the page's own
 * address, e.g. `/artist/f-n-souza/`.
 */
export interface IPageLocation {
  pathname: string;
}

/** Absolute URL for a root-relative page or asset path. */
export const absoluteUrl = (path: string): string =>
  `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;

/**
 * Absolute URL of the page currently rendering, so that a page states its own
 * address once, from what Gatsby already knows, rather than in a literal that
 * then has to be kept in sync.
 */
export const pageUrl = (location: IPageLocation): string =>
  absoluteUrl(location.pathname);
